import React from "react";

const paths = {
  mail: <><rect x="3" y="5" width="18" height="14" rx="3"/><path d="m4 7 8 6 8-6"/></>,
  key: <><circle cx="8" cy="9" r="5"/><path d="m12 13 8 8m-4-4 3-3m-6 0 3-3"/></>,
  check: <path d="m5 12 4 4L19 6"/>,
  sliders: <><path d="M4 7h6m4 0h6M4 17h10m4 0h2"/><circle cx="12" cy="7" r="2"/><circle cx="16" cy="17" r="2"/></>,
  heart: <path d="M20 5c-3-3-6-1-8 1-2-2-5-4-8-1-4 4 1 9 8 15 7-6 12-11 8-15Z"/>,
  history: <path d="M3 10a9 9 0 1 1 2 8M3 4v6h6M12 7v5l3 2"/>,
  library: <><rect x="5" y="5" width="16" height="16" rx="3"/><path d="M2 16V4a2 2 0 0 1 2-2h12m-5 7 5 4-5 4V9Z"/></>,
  shield: <><path d="m12 2 9 4v6c0 5-9 10-9 10S3 17 3 12V6l9-4Z"/><path d="m8 12 3 3 5-6"/></>,
  globe: <><circle cx="12" cy="12" r="9"/><ellipse cx="12" cy="12" rx="4" ry="9"/><path d="M3 12h18"/></>,
  bell: <path d="M5 10a7 7 0 0 1 14 0v5l2 3H3l2-3v-5m4 11h6"/>,
  devices: <><rect x="2" y="4" width="14" height="12" rx="2"/><path d="M6 20h6m-3-4v4"/><rect x="17" y="9" width="5" height="12" rx="1"/></>,
  user: <><circle cx="12" cy="7" r="4"/><path d="M4 22v-3a8 8 0 0 1 16 0v3"/></>,
  close: <path d="m6 6 12 12M18 6 6 18" />,
  send: (
    <>
      <path d="m5 12 7-7 7 7M12 5v14" />
    </>
  ),
  compass: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="m16 8-2 6-6 2 2-6 6-2Z" />
    </>
  ),
  play: <path d="m9 5 11 7-11 7V5Z" fill="currentColor" stroke="none" />,
  arrow: <path d="M5 12h14m-6-6 6 6-6 6" />,
  next: <path d="m9 5 7 7-7 7" />,
  previous: <path d="m15 5-7 7 7 7" />,
  pause: <path d="M9 5v14M15 5v14" />,
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v6m0-10v1" />
    </>
  ),
  tv: (
    <>
      <rect x="3" y="5" width="18" height="13" rx="3" />
      <path d="M8 22h8M12 18v4" />
    </>
  ),
  sparkle: (
    <>
      <path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5L12 3Z" />
      <path d="m20 2 .5 1.5L22 4l-1.5.5L20 6l-.5-1.5L18 4l1.5-.5L20 2Z" />
    </>
  ),
  search: (
    <>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="m16 16 5 5" />
    </>
  ),
  down: <path d="m6 9 6 6 6-6" />
};

export default function CinemaIcon({ name, ...props }) {
  return (
    <svg
      data-directional={["arrow", "next", "previous"].includes(name) ? "true" : undefined}
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {paths[name] || paths.play}
    </svg>
  );
}
